import { Resource } from "../resource/resource.model";

export class PreferencePage extends Resource {
    id: string;
    name: string;
    description: string;
    status: string;
    form_Id: string;
    html: string;
    headerHtml: string;
    footerHtml: string;
    customCss: string;
    controlId: string;
    headerScript: string;
    footerScript: string;
    businessUnit: string;
    i18nLanguage: string;
    tenantId: string;
    generalCorePreferences: any[];
    includeEmailSearch: boolean;
    redirectUrl: string;
    advancedHtml: string;
    isAdvancedMode: boolean;
    includeUnsubscribe: boolean;
    uiTranslations?: { [uiKey: string]: { [lang: string]: string } };
}